<script>

</script>

<div>
    <nav class="navbar navbar-dark bg-green">
        <span class="navbar-brand mb-0 h1">Tarea con Svelte - Lista de Tareas</span>
      </nav>
</div>

<style>

</style>
